import { useMutation } from '@tanstack/react-query';

import { ResetPasswordEmailData } from '../../../../types/requests';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { postSendResetPasswordEmail } from '../../requests/postSendResetPasswordEmail';

type SendResetPasswordEmailVariables = {
  data: ResetPasswordEmailData;
  headers?: Record<string, string>;
};

export const useSendResetPasswordEmail = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({ data, headers }: SendResetPasswordEmailVariables) =>
      postSendResetPasswordEmail(constructPost, data, headers),
    onError: (error: ApiErrorResponse) =>
      handleError(
        getApiErrorMessage(error, 'Failed to send password reset email.'),
      ),
  });
  return { sendResetPasswordEmail: mutateAsync, ...rest };
};
